import { html as beautifyHtml } from 'js-beautify'

export default function formatHtml (source) {
  if (!source || typeof source !== 'string') return source
  try {
    return beautifyHtml(source, {
      indent_size: 2,
      preserve_newlines: true,
      max_preserve_newlines: 1,
      end_with_newline: false,
      wrap_line_length: 0,
      wrap_attributes: 'auto',
      indent_inner_html: false,
      unformatted: []
    })
  } catch (e) {
    return source
  }
}
